
import React from 'react';
import { KeyboardBackspace, Edit, Check, Close, ShoppingCart, LocalShipping, AttachMoney, Receipt, CheckCircle, Cancel, Info } from '@material-ui/icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Cookies from "universal-cookie";
// يرجى استبدال هذا بملف Host الخاص بك أو عنوان API
// import host from '../../assets/js/Host';
import host from '../../assets/js/Host';

const cookies = new Cookies();

// Modern Color Palette
const colors = {
    primary: '#7c3aed',
    primaryDark: '#6d28d9',
    secondary: '#ec4899',
    success: '#10b981',
    warning: '#f59e0b',
    danger: '#ef4444',
    info: '#3b82f6',
    dark: '#1f2937',
    light: '#f3f4f6',
    white: '#ffffff'
};

class ModernInvoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            items_sana: [],
            t_price: 0,
            type: "",
            paid_amount: '',
            r_amount: '',
            status: '',
            shipping: '',
            add_at: '',
            supplierName: '',
            Getid: "",
            msg: "",
            is_transfer: false,
            safeCheck: false,
            notes: '',
            showEditShipping: false,
            showConfirmDialog: false,
            isConfirmLoading: false,
            role: Number(localStorage.getItem('role')) || -1
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const Getid = urlParams.get('id');
        const userRole = Number(localStorage.getItem('role')) || 0;

        //console.log('Component mounted - ID:', Getid, 'Role:', userRole);
        this.setState({ Getid, role: userRole });

        if (Getid) {
            this.fetchBillData(Getid);
            this.fetchSanaData(Getid);
        }
    }

    fetchBillData = (id) => {
        const header = {
            "Content-Type": "application/x-www-form-urlencoded",
            token: cookies.get("token")
        };

        //console.log('Fetching bill data with headers:', header);

        axios.get(host + `dashbord/bill/get/${id}`, { headers: header })
            .then(res => {
                const bill = res.data.bills;
                //console.log('Bill data received:', bill);
                //console.log('Current status:', bill.status, 'Current role:', this.state.role);

                let msg = "";
                const statusMessages = {
                    0: 'غير مدققة',
                    1: 'انتظار',
                    2: 'تم الادخال الى المخزن',
                    3: 'ملغية'
                };
                msg = statusMessages[bill.status] || '';

                this.setState({
                    items: bill.item,
                    t_price: bill.t_amount,
                    is_transfer: bill.is_transfer,
                    paid_amount: bill.paid_amount,
                    r_amount: bill.r_amount,
                    type: bill.type,
                    status: bill.status,
                    shipping: bill.shipping,
                    notes: bill.notes,
                    safeCheck: bill.safeCheck,
                    add_at: bill.add_at,
                    supplierName: bill.suppliers.name,
                    msg
                });
            })
            .catch(error => {
                console.error('Error fetching bill data:', error);
                console.error('Error response:', error.response);
                toast.error('حدث خطأ في جلب بيانات الفاتورة');
            });
    };

    fetchSanaData = (id) => {
        const header = {
            "Content-Type": "application/x-www-form-urlencoded",
            token: cookies.get("token")
        };

        axios.get(host + `dashbord/sana/bill/reports/${id}`, { headers: header })
            .then(res => {
                const items = res.data.items;
                const processedItems = items.map(item => {
                    const statusMap = {
                        "-1": "معلق في الصيانة",
                        "0": "سوفت",
                        "1": "فحص",
                        "2": "جاهز للمخزن",
                        "3": "في المخزن",
                        "5": "معلق في السوفت",
                        '4': "ملغي"
                    };

                    return {
                        id: item.id,
                        dw_price: item.dw_price,
                        parts_costs: item.parts_costs,
                        softCost: item.softCost,
                        battery: item.battery,
                        paybass: item.paybass ? "نعم" : "كلا",
                        status: statusMap[item.status],
                        item_in: item.item_in,
                        item_in_id: item.item_in_id,
                        item_out: item.item_out,
                        item_out_id: item.item_out_id
                    };
                });

                this.setState({ items_sana: processedItems });
            })
            .catch(error => {
                console.error(error);
            });
    };

    getStatusInfo = (status) => {
        const statusData = {
            0: { text: 'غير مدققة', color: colors.warning, icon: <Info /> },
            1: { text: 'انتظار', color: colors.info, icon: <LocalShipping /> },
            2: { text: 'تم الادخال الى المخزن', color: colors.success, icon: <CheckCircle /> },
            3: { text: 'ملغية', color: colors.danger, icon: <Cancel /> }
        };
        return statusData[status] || { text: '', color: colors.dark, icon: <Receipt /> };
    };

    formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('ar-SA', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        });
    };

    handleEditShipping = () => {
        const newPrice = document.getElementById('editshp').value;
        if (!newPrice || newPrice === '') {
            toast.error('يرجى إدخال سعر صحيح');
            return;
        }

        //console.log('Sending shipping price update:', newPrice);

        const formData = new URLSearchParams();
        formData.append('prcie', newPrice); // Note: API expects 'prcie'

        axios.post(host + `dashbord/bill/shpinng/edit/${this.state.Getid}`, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': cookies.get("tokenUser") || cookies.get("token")
            }
        })
            .then(response => {
                //console.log('Edit shipping response:', response);
                toast.success('تم تحديث سعر الشحن بنجاح');
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            })
            .catch(error => {
                console.error('Edit shipping error:', error.response);
                toast.error('حدث خطأ في تحديث سعر الشحن');
            });
    };

    handleStatusChange = (newStatus) => {
        //console.log('Sending status change request:', newStatus);

        // تجربة مع header مختلف بناءً على الكود الأصلي
        const formData = new URLSearchParams();
        formData.append('status', newStatus);

        axios.post(host + `dashbord/bill/shpinng/status/${this.state.Getid}`, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': cookies.get("tokenUser") || cookies.get("token")
            }
        })
            .then(response => {
                //console.log('Status change response:', response);
                const statusInfo = this.getStatusInfo(newStatus);
                toast.success(`تم تغيير الحالة إلى: ${statusInfo.text}`);
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            })
            .catch(error => {
                console.error('Status change error:', error);
                console.error('Error response:', error.response);
                console.error('Error details:', {
                    status: error.response?.status,
                    data: error.response?.data,
                    headers: error.response?.headers
                });
                toast.error(`حدث خطأ: ${error.response?.data?.message || 'فشل تغيير الحالة'}`);
            });
    };

    handleInventoryEntry = () => {
        this.setState({ isConfirmLoading: true });

        const safeOut = document.getElementById('safeOut')?.checked || false;
        //console.log('Sending inventory entry request, safeOut:', safeOut);

        const formData = new URLSearchParams();
        formData.append('safeOut', safeOut);

        axios.post(host + `dashbord/bill/shpinng/in/${this.state.Getid}`, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': cookies.get("tokenUser") || cookies.get("token")
            }
        })
            .then(response => {
                //console.log('Inventory entry response:', response);
                toast.success('تم إدخال القائمة للمخزن بنجاح');
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            })
            .catch(error => {
                console.error('Inventory entry error:', error.response);
                toast.error('حدث خطأ في إدخال القائمة للمخزن');
                this.setState({ isConfirmLoading: false });
            });
    };

    render() {
        // Check authentication
        if (!cookies.get("token")) {
            // Return login component or redirect
            return (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    backgroundColor: '#f0f2f5'
                }}>
                    <div style={{
                        textAlign: 'center',
                        padding: '2rem',
                        backgroundColor: 'white',
                        borderRadius: '10px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}>
                        <h2>يرجى تسجيل الدخول</h2>
                        <p>ليس لديك صلاحية لعرض هذه الصفحة</p>
                    </div>
                </div>
            );
        }
        const {
            items, t_price, shipping, paid_amount, r_amount,
            supplierName, add_at, notes, status, type,
            is_transfer, safeCheck, showEditShipping, showConfirmDialog,
            isConfirmLoading, role
        } = this.state;

        const statusInfo = this.getStatusInfo(status);

        const styles = {
            container: {
                minHeight: '100vh',
                backgroundColor: '#f0f2f5',
                fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
                direction: 'rtl'
            },
            header: {
                background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
                padding: '2rem 0',
                marginBottom: '2rem',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
            },
            headerContent: {
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '0 2rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            },
            headerTitle: {
                color: colors.white,
                fontSize: '2rem',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
                gap: '1rem'
            },
            backButton: {
                backgroundColor: 'rgba(255,255,255,0.2)',
                border: 'none',
                borderRadius: '50%',
                padding: '0.7rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            mainContent: {
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '0 2rem 2rem'
            },
            card: {
                backgroundColor: colors.white,
                borderRadius: '16px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07)',
                padding: '2rem',
                marginBottom: '1.5rem',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                border: '1px solid rgba(0,0,0,0.05)'
            },
            statusBadge: {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.75rem 1.5rem',
                borderRadius: '30px',
                fontSize: '1rem',
                fontWeight: '600',
                backgroundColor: statusInfo.color + '20',
                color: statusInfo.color,
                marginBottom: '2rem'
            },
            gridContainer: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '1.5rem',
                marginBottom: '2rem'
            },
            inputGroup: {
                position: 'relative'
            },
            label: {
                display: 'block',
                marginBottom: '0.5rem',
                color: colors.dark,
                fontSize: '0.9rem',
                fontWeight: '600'
            },
            input: {
                width: '100%',
                padding: '0.875rem 1rem',
                borderRadius: '10px',
                border: `2px solid ${colors.light}`,
                backgroundColor: '#fafafa',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                textAlign: 'center',
                fontFamily: 'inherit'
            },
            inputWrapper: {
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'center'
            },
            editButton: {
                backgroundColor: colors.warning,
                color: colors.white,
                border: 'none',
                borderRadius: '10px',
                padding: '0.875rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            table: {
                width: '100%',
                borderCollapse: 'separate',
                borderSpacing: '0',
                overflow: 'hidden',
                borderRadius: '12px',
                boxShadow: '0 0 0 1px rgba(0,0,0,0.05)'
            },
            tableHeader: {
                backgroundColor: colors.primary,
                color: colors.white,
                padding: '1rem',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '0.95rem'
            },
            tableCell: {
                padding: '1rem',
                textAlign: 'center',
                borderBottom: `1px solid ${colors.light}`,
                backgroundColor: colors.white,
                fontSize: '0.95rem'
            },
            summarySection: {
                background: `linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)`,
                borderRadius: '12px',
                padding: '1.5rem',
                marginTop: '2rem'
            },
            summaryGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '1.5rem'
            },
            summaryItem: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.75rem',
                backgroundColor: colors.white,
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            },
            summaryLabel: {
                fontSize: '0.9rem',
                color: '#6b7280',
                fontWeight: '500'
            },
            summaryValue: {
                fontSize: '1.1rem',
                fontWeight: '700'
            },
            checkbox: {
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '1rem',
                backgroundColor: '#f9fafb',
                borderRadius: '8px',
                marginBottom: '0.75rem'
            },
            actionButton: {
                padding: '0.875rem 2rem',
                borderRadius: '10px',
                border: 'none',
                fontWeight: '600',
                fontSize: '1rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            },
            modal: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                backdropFilter: 'blur(4px)'
            },
            modalContent: {
                backgroundColor: colors.white,
                borderRadius: '16px',
                padding: '2rem',
                maxWidth: '500px',
                width: '90%',
                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                animation: 'modalFadeIn 0.3s ease'
            },
            modalTitle: {
                fontSize: '1.5rem',
                fontWeight: 'bold',
                marginBottom: '1.5rem',
                textAlign: 'center',
                color: colors.dark
            }
        };

        return (
            <div style={styles.container}>
                <ToastContainer position="top-center" rtl />

                {/* Header */}
                <header style={styles.header}>
                    <div style={styles.headerContent}>
                        <h1 style={styles.headerTitle}>
                            <Receipt style={{ fontSize: '2.5rem' }} />
                            فاتورة المنزلية
                        </h1>
                        <button
                            style={styles.backButton}
                            onClick={() => window.location.href = '/billsList'}
                            onMouseEnter={e => e.target.style.backgroundColor = 'rgba(255,255,255,0.3)'}
                            onMouseLeave={e => e.target.style.backgroundColor = 'rgba(255,255,255,0.2)'}
                        >
                            <KeyboardBackspace style={{ color: colors.white, fontSize: '1.5rem' }} />
                        </button>
                    </div>
                </header>

                {/* Main Content */}
                <main style={styles.mainContent}>
                    <div style={styles.card}>
                        {/* Status Badge */}
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={styles.statusBadge}>
                                {statusInfo.icon}
                                {statusInfo.text}
                            </div>
                        </div>

                        {/* Form Fields */}
                        <div style={styles.gridContainer}>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>اسم التاجر</label>
                                <input style={styles.input} value={supplierName} disabled />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>تاريخ القائمة</label>
                                <input style={styles.input} value={this.formatDate(add_at)} disabled />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>سعر التوصيل</label>
                                <div style={styles.inputWrapper}>
                                    <input style={styles.input} value={shipping} disabled />
                                    {type === 1 && status !== 2 && status !== 3 && (
                                        <button
                                            style={styles.editButton}
                                            onClick={() => this.setState({ showEditShipping: true })}
                                            onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                                            onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                                        >
                                            <Edit />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div style={styles.gridContainer}>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>نوع النقل</label>
                                <input style={styles.input} value={type === 0 ? 'داخلي' : 'خارجي'} disabled />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>الحالة</label>
                                <input style={styles.input} value={statusInfo.text} disabled />
                            </div>

                            <div style={styles.inputGroup}>
                                <label style={styles.label}>ملاحظات</label>
                                <input style={styles.input} value={notes} disabled />
                            </div>
                        </div>
                    </div>

                    {/* Items Table */}
                    <div style={styles.card}>
                        <h3 style={{ marginBottom: '1.5rem', color: colors.dark, fontSize: '1.3rem' }}>
                            تفاصيل المنتجات
                        </h3>
                        <div style={{ overflowX: 'auto', borderRadius: '12px' }}>
                            <table style={styles.table}>
                                <thead>
                                    <tr>
                                        <th style={styles.tableHeader}>#</th>
                                        <th style={styles.tableHeader}>ID</th>
                                        <th style={styles.tableHeader}>المنتج</th>
                                        <th style={styles.tableHeader}>العدد</th>
                                        <th style={styles.tableHeader}>سعر القطعة</th>
                                        <th style={styles.tableHeader}>السعر الكلي</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item, i) => (
                                        <tr key={i}>
                                            <td style={{ ...styles.tableCell, fontWeight: 'bold' }}>{i + 1}</td>
                                            <td style={styles.tableCell}>{item.id}</td>
                                            <td style={{ ...styles.tableCell, fontWeight: '500' }}>{item.name}</td>
                                            <td style={styles.tableCell}>{item.count}</td>
                                            <td style={styles.tableCell}>{item.price.toFixed(2)}</td>
                                            <td style={{ ...styles.tableCell, fontWeight: 'bold', color: colors.primary }}>
                                                {(item.price * item.count).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Summary Section */}
                        <div style={styles.summarySection}>
                            <div style={styles.summaryGrid}>
                                <div style={styles.summaryItem}>
                                    <span style={styles.summaryLabel}>المبلغ المدفوع</span>
                                    <span style={{ ...styles.summaryValue, color: colors.success }}>{paid_amount}</span>
                                </div>
                                <div style={styles.summaryItem}>
                                    <span style={styles.summaryLabel}>مصاريف اخرى</span>
                                    <span style={{ ...styles.summaryValue, color: colors.danger }}>{shipping}</span>
                                </div>
                                <div style={styles.summaryItem}>
                                    <span style={styles.summaryLabel}>المبلغ المتبقي</span>
                                    <span style={{ ...styles.summaryValue, color: colors.warning }}>{r_amount}</span>
                                </div>
                                <div style={styles.summaryItem}>
                                    <span style={styles.summaryLabel}>المجموع الكلي</span>
                                    <span style={{ ...styles.summaryValue, color: colors.primary, fontSize: '1.3rem' }}>
                                        {t_price + shipping}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Options & Actions */}
                    <div style={styles.card}>
                        {/* Checkboxes */}
                        <div style={{ marginBottom: '1.5rem' }}>
                            {is_transfer === 1 && (
                                <div style={styles.checkbox}>
                                    <input type="checkbox" checked disabled />
                                    <label>تم الدفع بواسطة حوالة</label>
                                </div>
                            )}

                            {status === 2 && safeCheck === 1 && (
                                <div style={styles.checkbox}>
                                    <input type="checkbox" checked disabled />
                                    <label>تم دفع مصاريف الشحن عن الاستلام فقط</label>
                                </div>
                            )}

                            {status === 1 && (
                                <div style={styles.checkbox}>
                                    <input type="checkbox" id="safeOut" />
                                    <label>اخراج مصاريف الشحن من القصة</label>
                                </div>
                            )}
                        </div>

                        {/* Action Buttons */}
                        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                            {status === 1 && (
                                <button
                                    style={{
                                        ...styles.actionButton,
                                        backgroundColor: colors.info,
                                        color: colors.white
                                    }}
                                    onClick={() => this.setState({ showConfirmDialog: true })}
                                    onMouseEnter={e => {
                                        e.target.style.transform = 'translateY(-2px)';
                                        e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
                                    }}
                                    onMouseLeave={e => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                                    }}
                                >
                                    <ShoppingCart />
                                    ادخال الى المخزن
                                </button>
                            )}

                            {status === 0 && role === -1 && (
                                <>
                                    <button
                                        style={{
                                            ...styles.actionButton,
                                            backgroundColor: colors.success,
                                            color: colors.white
                                        }}
                                        onClick={() => {
                                            //console.log('Accept button clicked');
                                            //console.log('Status:', status, 'Role:', role, 'ID:', this.state.Getid);
                                            this.handleStatusChange(1);
                                        }}
                                        onMouseEnter={e => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
                                        }}
                                        onMouseLeave={e => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                                        }}
                                    >
                                        <Check />
                                        قبول
                                    </button>

                                    <button
                                        style={{
                                            ...styles.actionButton,
                                            backgroundColor: colors.danger,
                                            color: colors.white
                                        }}
                                        onClick={() => {
                                            //console.log('Reject button clicked');
                                            //console.log('Status:', status, 'Role:', role, 'ID:', this.state.Getid);
                                            this.handleStatusChange(3);
                                        }}
                                        onMouseEnter={e => {
                                            e.target.style.transform = 'translateY(-2px)';
                                            e.target.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
                                        }}
                                        onMouseLeave={e => {
                                            e.target.style.transform = 'translateY(0)';
                                            e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                                        }}
                                    >
                                        <Close />
                                        رفض
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </main>

                {/* Edit Shipping Modal */}
                {showEditShipping && (
                    <div style={styles.modal}>
                        <div style={styles.modalContent}>
                            <h3 style={styles.modalTitle}>تعديل سعر التوصيل</h3>
                            <div style={styles.inputGroup}>
                                <label style={styles.label}>السعر الجديد</label>
                                <input
                                    id="editshp"
                                    type="number"
                                    style={{ ...styles.input, textAlign: 'right' }}
                                    placeholder="ادخل السعر الجديد"
                                    autoFocus
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '1rem', marginTop: '2rem' }}>
                                <button
                                    style={{
                                        ...styles.actionButton,
                                        backgroundColor: colors.primary,
                                        color: colors.white,
                                        flex: 1
                                    }}
                                    onClick={this.handleEditShipping}
                                >
                                    تعديل
                                </button>
                                <button
                                    style={{
                                        ...styles.actionButton,
                                        backgroundColor: colors.light,
                                        color: colors.dark,
                                        flex: 1
                                    }}
                                    onClick={() => this.setState({ showEditShipping: false })}
                                >
                                    إلغاء
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Confirm Dialog */}
                {showConfirmDialog && (
                    <div style={styles.modal}>
                        <div style={styles.modalContent}>
                            <h3 style={styles.modalTitle}>قبول القائمة</h3>
                            <div style={{
                                backgroundColor: colors.danger + '10',
                                border: `2px solid ${colors.danger}30`,
                                borderRadius: '10px',
                                padding: '1.5rem',
                                marginBottom: '2rem',
                                textAlign: 'center'
                            }}>
                                <Cancel style={{ fontSize: '3rem', color: colors.danger, marginBottom: '1rem' }} />
                                <p style={{ color: colors.danger, fontSize: '1.1rem', fontWeight: '500' }}>
                                    هل تريد فعلاً ادخال هذه القائمة للمخزن؟
                                </p>
                            </div>
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <button
                                    style={{
                                        ...styles.actionButton,
                                        backgroundColor: isConfirmLoading ? colors.light : colors.primary,
                                        color: isConfirmLoading ? colors.dark : colors.white,
                                        flex: 1,
                                        cursor: isConfirmLoading ? 'not-allowed' : 'pointer'
                                    }}
                                    onClick={this.handleInventoryEntry}
                                    disabled={isConfirmLoading}
                                >
                                    {isConfirmLoading ? 'جاري الإضافة...' : 'إضافة'}
                                </button>
                                <button
                                    style={{
                                        ...styles.actionButton,
                                        backgroundColor: colors.light,
                                        color: colors.dark,
                                        flex: 1
                                    }}
                                    onClick={() => this.setState({ showConfirmDialog: false })}
                                    disabled={isConfirmLoading}
                                >
                                    إلغاء
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <style>{`
          @keyframes modalFadeIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
            </div>
        );
    }
}

export default ModernInvoice;